import { IValidation } from '../validation.interfaces';
export class CompareValidation implements IValidation {
    validate(parameters: any, object: any): boolean | Promise<boolean> {
        const operation = parameters.operation;
        const otherPropertyAccessor = parameters.otherProperty;
        const propertyAccessor = parameters.property;
        let value = parameters.value;
        if(otherPropertyAccessor){
            value = object[otherPropertyAccessor];
        }
        switch (operation) {
            case Operation.Equal:
                return object[propertyAccessor] == value;
            case Operation.GreaterThan:
                return object[propertyAccessor] > value;
            case Operation.GreaterThanOrEqual:
                return object[propertyAccessor] >= value;
            case Operation.LessThan:
                return object[propertyAccessor] < value;
            case Operation.LessThanOrEqual:
                return object[propertyAccessor] <= value;
            default:
                return false;
        }
    }

    canValidate(): boolean | Promise<boolean> {
        return true;
    }
}

export enum Operation {
    Equal,
    GreaterThan,
    GreaterThanOrEqual,
    LessThan,
    LessThanOrEqual
}
